import * as React from "react";
import * as moment from "moment";
import { __, __BETA, __TRIAL_DATE } from "src/services/theme";

const HTML = (props) => (
    <section className="info">
    
      <header>
        <div className="container">
          <h1>Premium Prof</h1>
          <p>
            Il massimo per la tua visibilità professionale.<br />
            Aumento esponenziale dei contatti  e dei tuoi guadagni.
          </p>
        </div>
      </header>
      
      {!__BETA &&
      <section> 
        <div className="container-prova-gratis super-tata">
          <h2>Provalo <strong>gratis </strong> per 30 giorni</h2>
          {!props.trialStatus &&
          <button className="button-p-g" onClick={() => { props.onTrial(); }}><span>Attiva</span></button>
          }
          {props.trialStatus === "loading" &&
          <button className="button-p-g"><span>Attivando</span></button>
          }
          {props.trialStatus === "active" &&
          <button className="button-p-g" disabled><span>Free trial attivata</span></button>
          }
          <p>Al termine della prova potrai sottoscrivere l’abbonamento annuale a soli 0,99€ al giorno. <br />
                  NON VALIDO PER CHI HA GIA’ USUFRUITO DEL PERIODO DI PROVA</p>
        </div>
    </section>
    }
      
    <div className="features container premium-tata row">
        <div className="p-t-wrapper">
           <h3> Il massimo per la tua visibilità professionale. <br />
             Aumento esponenziale dei contatti  e dei tuoi guadagni.</h3> 
           <h2>  Tutto il pacchetto Free Prof <br /> <strong> + </strong></h2>
        </div>
        <div className="icon-free-profile col-xs-12 col-lg-4 col-sm-4 ">
          <div className="orange center-icon"><span className="icon-resume"></span></div>
          <p>NUMERO TELEFONO IN CHIARO</p>
        </div>
        <div className="icon-free-profile col-xs-12 col-lg-4 col-sm-4 ">
          <div className="orange center-icon"><span className="icon-mail"></span></div>
          <p>EMAIL IN CHIARO</p>
        </div>
        <div className="icon-free-profile col-xs-12 col-lg-4 col-sm-4 ">
          <div className="orange center-icon"><span className="icon-skype"></span></div>
          <p>CONTATTO SKYPE IN CHIARO</p>
        </div>
    </div>

      {!__BETA &&
      <div className="cta cta-premium-tata">
        <div className="container">
          <h2>Sottoscrivi PREMIUM</h2>
          <article>
            <span className="price">
              <small>&euro;</small>
              <strong>0,99</strong>
              <span>/giorno</span>
            </span>
            {!props.activated &&
            <button  className="button-p-g" onClick={() => props.onClick()}><span>Sottoscrivi</span></button>
            }
            {props.activated &&
            <button  className="button-p-g" disabled><span>Già attivato</span></button>
            }
          </article>
          <p>€360/anno - xxx crediti. Abbonamento annuale prepagato.</p>
        </div>
      </div>
      }
      {__BETA && __TRIAL_DATE &&
      <div className="cta cta-premium-tata">
        <div className="container">
          <h2>
            Premium Prof è gratis
            <small>fino al {moment(__TRIAL_DATE).format('DD/MM/YYYY')}</small>
          </h2>
        </div>
      </div>
      }
      
      <div className="faq container">
        <h2><span>Domande frequenti</span></h2>
        <div className="items">
          <article>
            <h4>{__('AcquistiProfPremium.faq2_title')}</h4>
            <p>{__('AcquistiProfPremium.faq2_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiProfPremium.faq3_title')}</h4>
            <p>{__('AcquistiProfPremium.faq3_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiProfPremium.faq4_title')}</h4>
            <p>{__('AcquistiProfPremium.faq4_text', 130)}</p>
          </article>
        </div>
      </div>
      
    </section>
);

export default HTML;


// WEBPACK FOOTER //
// ./src/components/ecommerce/AcquistiDocenteInfo/Premium.tsx